
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.93 14.268A9.406 9.406 0 0 0 11.133 2.982a5.455 5.455 0 0 0-7.607 7.376 9.406 9.406 0 0 0 10.938 11.14 5.454 5.454 0 0 0 7.466-7.23Zm-4.364 2.477c-.436.616-1.078 1.104-1.911 1.45-.825.343-1.814.517-2.94.517-1.35 0-2.483-.238-3.367-.707a4.414 4.414 0 0 1-1.549-1.374c-.4-.576-.602-1.148-.602-1.7 0-.344.132-.643.392-.888.258-.242.588-.365.982-.365.323 0 .602.097.829.289.216.183.402.454.551.805.167.382.349.704.54.958.185.244.45.45.79.61.34.161.8.243 1.365.243.778 0 1.415-.166 1.895-.493.468-.32.696-.704.696-1.174 0-.371-.119-.663-.363-.892-.256-.24-.594-.426-1.004-.554a19.5 19.5 0 0 0-1.725-.427c-.973-.208-1.8-.455-2.458-.735a.249.249 0 0 1-.008-.003c-.674-.287-1.218-.684-1.615-1.182-.404-.506-.609-1.14-.609-1.885 0-.71.215-1.351.639-1.904.42-.548 1.035-.975 1.825-1.267.781-.289 1.71-.435 2.76-.435.84 0 1.579.097 2.195.289.62.193 1.143.453 1.553.774.414.323.722.67.915 1.028.195.363.294.724.294 1.073 0 .336-.13.642-.386.908a1.292 1.292 0 0 1-.966.404c-.348 0-.62-.085-.81-.253-.176-.156-.358-.398-.561-.747-.235-.446-.518-.797-.844-1.045-.316-.24-.845-.362-1.57-.362-.675 0-1.223.135-1.63.402-.392.257-.583.552-.583.902a.83.83 0 0 0 .188.547c.133.163.322.307.56.426.247.124.502.223.757.293.262.073.7.18 1.302.32a23.247 23.247 0 0 1 2.079.544c.626.2 1.168.447 1.609.734.45.294.807.67 1.06 1.12.254.452.383 1.01.383 1.657 0 .775-.222 1.48-.659 2.099Z","fill":"#03A9F4"}})])
          )
        }
      }
    